import React from "react";
import employeeData from "../../assets/dummy-data/employeeData";

const maxLength = 4;

const NewlyBoardedCard = () => {
  const data = employeeData.slice(0, maxLength);
  return (
    <div>
     
        <div className="display__section" >
          <div className="personal__section">
            <div className="employee__img">
              
            </div>
            <div className="emp__details">
              <h6></h6>
              <p></p>
            </div>
          </div>
          <div
            
          >
            <span>
              <i className=""></i>
            </span>
            <p></p>
          </div>
        </div>
     
    </div>
  );
};

export default NewlyBoardedCard;
